// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAUhMreftMnOXMl9mQN6Rz9FmAqT8zU_Zg',
    authDomain: 'thecampus-colegios.firebaseapp.com',
    projectId: 'thecampus-colegios',
    databaseURL: 'https://thecampus-colegios-default-rtdb.firebaseio.com',
    storageBucket: 'thecampus-colegios.firebasestorage.app',
    messagingSenderId: '54461007828',
    appId: '1:54461007828:web:7d14aa43e208488c6a7841',
    measurementId: 'G-7V0NKRE24C',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
